module.exports = __webpack_public_path__ + "img/201110-4.6607d8db.png";